<template>
  <div style="z-index: 1000">
    <v-app-bar class="app-bar-color" clipped-left app>
      <v-app-bar-nav-icon
        @click="onClick"
        style="color: white;"
      ></v-app-bar-nav-icon>
      <!-- <v-toolbar-title>Dashboard</v-toolbar-title> -->
      <v-spacer></v-spacer>
      <v-col cols="12" md="3" class="d-flex justify-end">
        <v-autocomplete
          v-model="biz_name"
          :items="list_items_biz"
          height="50px"
          dense
          solo
          class="custom-autocomplete"
          @change="selectBiz()"
        ></v-autocomplete>
      </v-col>
      <v-menu offset-y style="z-index: 1001">
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            dark
            v-bind="attrs"
            v-on="on"
            style="font-size: 5vh; cursor: pointer;"
            >mdi-account-circle</v-icon
          >
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
            style="font-size: 2vh; cursor: pointer"
            @click="logout()"
          >
            <v-list-item-title>
              <v-icon>mdi-logout</v-icon>
              {{ item.title }}</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-menu>
      <div style="width:2px"></div>
      <div class="text_d" style="display: block; color: white;">
        {{ employee_id }}
        <div style="width: 10px;color: white;"></div>
        {{ role_name }}
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import eventBus from "../event-bus";
export default {
  data() {
    return {
      employee_id: "",
      role_name: "",
      test: 0,
      biz_name: "",
      items_biz: [],
      list_items_biz: [],
      items: [
        {
          title: "LOGOUT",
          // link: "/",
          show: true,
        },
      ],
    };
  },
  created() {
    this.employee_id = localStorage.getItem("employee_id");
    this.role_name =
      localStorage.getItem("first_name_th") +
      " " +
      localStorage.getItem("last_name_th");

    this.items_biz = JSON.parse(localStorage.getItem('biz_all'));
    
    if(this.items_biz){
      this.items_biz.forEach((element => {
        this.list_items_biz.push(element.first_name_th)
      }))
    }

    this.biz_name = localStorage.getItem("biz_name");
  },
  methods: {
    logout() {
      localStorage.clear();
      this.$router.push("/login");
    },
    onClick() {
      eventBus.$emit("click");
      // this.test += 1;
      // if(this.test % 2 == 0){
      //   this.test = true
      // }else {
      //   this.test = false
      // }
      // console.log(this.test);
      // localStorage.setItem('test', JSON.stringify({
      //       cilck: this.test,
      // }))
    },
    selectBiz() {
      if(this.items_biz){
        this.items_biz.forEach((element => {
          if(element.first_name_th == this.biz_name){
            if(element.role != "" ){
              localStorage.setItem("biz_id" , element.id);
              localStorage.setItem("role" , element.role);
              localStorage.setItem("sorgcode" , element.company_code);
              localStorage.setItem("biz_name" , this.biz_name);
              this.$router.push("/invoice");
              window.location.reload();
            }else{
              this.$swal.fire({
                title: "<h4>ไม่พบสิทธิ์การเข้าใช้งานของ</h4>",
                text: this.biz_name,
                icon: "error",
                showConfirmButton: false,
                timer: 3000,
              });
              // this.biz_name = localStorage.getItem("biz_name");
            }
            
          }
        }))
      }
      
      
      
    }
  },
};
</script>

<style lang="scss">
// @font-face {
//   font-family: "Bai_Jamjuree";
//   src: url("~@/assets/Bai_Jamjuree/Bai_Jamjuree-Regular.ttf") format("truetype");
//   font-weight: 400;
//   font-style: normal;
// }

// @font-face {
//   font-family: "Bai_Jamjuree";
//   src: url("~@/assets/Bai_Jamjuree/Bai_Jamjuree-Thin.ttf") format("truetype");
//   font-weight: 300;
//   font-style: normal;
// }
@font-face {
  font-family: "Bai_Jamjuree";
  src: url("~@/assets/Bai_Jamjuree/BaiJamjuree-Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
  line-height: 2rem;
}
.text_d {
  font-family: "Bai_Jamjuree" !important;
  font-size: 13px;
}
.app-bar-color {
  background: #ffffff !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #47a6e0,
    #25d599
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #47a6e0, #25d599) !important;
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
.custom-autocomplete {
  width: 160px !important;
  margin-top: 25px !important;
  z-index: 1001 !important;
  font-size: 16px !important;
  font-family: "Bai_Jamjuree" !important;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none 0px 2px 4px 0px #60617029;
}
.v-select__slot {
  position: relative !important;
  align-items: center !important;
  display: flex !important;
  max-width: 100% !important;
  min-width: 0% !important;
  width: 100% !important;
  min-height: 48px !important;
  height: 100% !important;
  border-radius: 0px !important;
  margin-top: 0px !important;
  font-size: 16px !important;
  font-family: "Bai_Jamjuree" !important;
}
.v-menu__content {
  position: absolute;
  display: inline-block;
  max-width: 80%;
  overflow-y: auto;
  overflow-x: hidden;
  contain: content;
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  border-radius: 6px !important;
  font-family: "Bai_Jamjuree" !important;
}
.v-text-field.v-text-field--solo .v-input__control input {
  font-size: 15px !important;
}
.v-list--dense .v-list-item .v-list-item__title {
  line-height: 1.5rem !important;
  font-size: 15px !important;
}
</style>
